"use client";
import { jsx as o, jsxs as r, Fragment as v } from "react/jsx-runtime";
import { useChatbotConversation as B } from "../../hooks/useChatbotConversation.js";
import { ChatbotContext as I } from "../../contexts/ChatbotContext.js";
import { Layout as M } from "./Layout.js";
import { ErrorMessage as x } from "./ErrorMessage.js";
import { ScrollWrapper as y } from "./ScrollWrapper.js";
import { MessagesList as P } from "./MessagesList.js";
import { Suggestions as U } from "./Suggestions.js";
import { UserMessageInput as j } from "./UserMessageInput.js";
import { UserMessageSendButton as F } from "./UserMessageSendButton.js";
import { UserMessageField as L } from "./UserMessageField.js";
import { UserMessageForm as k } from "./UserMessageForm.js";
import { EmbedPopupHeader as D } from "./EmbedPopupHeader.js";
import { InactivityIndicator as H } from "./InactivityIndicator.js";
import { StopButton as w } from "./StopButton.js";
function Y({ className: n, ...m }) {
  const t = B(m), {
    chatError: a,
    chatStatus: d,
    isBuilder: e,
    isDisabled: l,
    isEmbedded: p,
    isEmptyConversation: c,
    isEnded: i,
    isError: u,
    isInitializing: f,
    isPopup: s,
    isReadonly: g,
    renderPoweredByZapier: h,
    loadingSlot: C,
    disabledSlot: b,
    handlePopupCloseButtonClick: E,
    projectIsHidden: S
  } = t;
  return /* @__PURE__ */ o(I.Provider, { value: t, children: /* @__PURE__ */ o(M, { className: n, children: f ? /* @__PURE__ */ o(C, {}) : l ? /* @__PURE__ */ o(b, {}) : u ? /* @__PURE__ */ o(x, {}) : c ? null : /* @__PURE__ */ r(v, { children: [
    s && /* @__PURE__ */ o(
      D,
      {
        onCloseButtonClick: E
      }
    ),
    /* @__PURE__ */ r(y, { children: [
      /* @__PURE__ */ o(P, {}),
      i && !e && /* @__PURE__ */ o(H, {})
    ] }),
    !a && !g && (!i || e) ? /* @__PURE__ */ r(k, { children: [
      /* @__PURE__ */ o(U, {}),
      /* @__PURE__ */ r(L, { children: [
        /* @__PURE__ */ o(j, {}),
        d === "streaming" ? /* @__PURE__ */ o(w, {}) : /* @__PURE__ */ o(F, {})
      ] })
    ] }) : null,
    p || s || S ? h() : null
  ] }) }) });
}
export {
  Y as ChatbotConversation
};
